module.exports = __webpack_public_path__ + "static/media/Noah-RegularItalic.70c781c3.woff";